import script from "./secondary-menu-item.vue?vue&type=script&setup=true&lang=js"
export * from "./secondary-menu-item.vue?vue&type=script&setup=true&lang=js"

import "./secondary-menu-item.vue?vue&type=style&index=0&id=73272cec&lang=postcss"

const __exports__ = script;

export default __exports__